import { FadeUp } from "./Reveal";
import { useLang } from "./LanguageContext";

const IMG = "https://static.prod-images.emergentagent.com/jobs/6918af59-ab46-445b-a012-e513807d76c0/images/";

const shots = [
  { src: `${IMG}037ac25fd70dc1688365904b814943c231e5a0c3011267ab1dcde18344383fe6.jpeg`, span: "md:col-span-7 md:row-span-2", ratio: "aspect-[4/5]" },
  { src: `${IMG}15eec68d6fbd0b4e12a8b442cca983121cae716376f3712ff50a17ad99b79109.jpeg`, span: "md:col-span-5", ratio: "aspect-[4/3]" },
  { src: `${IMG}9d26ff7c5da6818188146c9cdaaf6b65eaabc4540139612cebe9dfd68ed7a488.jpeg`, span: "md:col-span-5", ratio: "aspect-[4/3]" },
  { src: `${IMG}7c71531afcee573168fdc2273605be0ddfbf24aef3273b302606f50a71c42e72.jpeg`, span: "md:col-span-6", ratio: "aspect-[3/2]" },
  { src: `${IMG}e9480ad1ea9ba0c23452a23ad6f7f11d7645e7ec08e0b4929355ad33b6a98abb.jpeg`, span: "md:col-span-6", ratio: "aspect-[3/2]" },
];

const copy = {
  en: {
    kicker: "Gallery",
    h2: <>The craft, <em className="italic">plated</em>.</>,
    alts: ["Burrata, torn open", "The stretch, by hand", "Deconstructed caprese", "Mozzarella & prosciutto", "Warm stracciatella"],
    note: (brand) => <>Handcrafted mozzarella, composed with restraint — the {brand} signature.</>,
    burrata: "Burrata — born in Puglia, the heart of southern Italy.",
  },
  it: {
    kicker: "Galleria",
    h2: <>Il mestiere, <em className="italic">nel piatto</em>.</>,
    alts: ["Burrata, aperta", "La filatura, a mano", "Caprese destrutturata", "Mozzarella e prosciutto", "Stracciatella calda"],
    note: (brand) => <>Mozzarella artigianale, composta con sobrietà — la firma {brand}.</>,
    burrata: "Burrata — nata in Puglia, il cuore del Sud Italia.",
  },
  ru: {
    kicker: "Галерея",
    h2: <>Ремесло, <em className="italic">на тарелке</em>.</>,
    alts: ["Буррата, раскрытая", "Вытягивание, вручную", "Деконструированное капрезе", "Моцарелла и прошутто", "Тёплая страчателла"],
    note: (brand) => <>Моцарелла ручной работы, поданная со сдержанностью — почерк {brand}.</>,
    burrata: "Буррата — родом из Апулии, сердца юга Италии.",
  },
  es: {
    kicker: "Galería",
    h2: <>El oficio, <em className="italic">en el plato</em>.</>,
    alts: ["Burrata, abierta", "El hilado, a mano", "Caprese deconstruida", "Mozzarella y prosciutto", "Stracciatella tibia"],
    note: (brand) => <>Mozzarella artesanal, compuesta con sobriedad — la firma {brand}.</>,
    burrata: "Burrata — nacida en Puglia, el corazón del sur de Italia.",
  },
};

const Tile = ({ s, alt }) => (
  <div className={`group relative overflow-hidden rounded-sm ${s.span}`} data-testid="gallery-tile">
    <div className={`${s.ratio} w-full h-full`}>
      <img
        src={s.src}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
      />
    </div>
    <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/30 transition-colors duration-500" />
    <p className="absolute bottom-4 left-4 font-serif italic text-xl text-bg opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
      {alt}
    </p>
  </div>
);

export const Gallery = ({ brand = "filata" }) => {
  const { lang } = useLang();
  const t = copy[lang];
  const brandName = brand === "patrizias" ? "Patrizia\u2019s" : "Filata";
  return (
    <section id="gallery" className="py-24 md:py-40 bg-[#ece1cd]" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.35em] text-ink-soft mb-5">{t.kicker}</p>
            <h2 className="font-serif text-4xl md:text-6xl text-ink leading-[1.05] max-w-xl">{t.h2}</h2>
          </div>
          <div className="max-w-xs">
            <p className="font-sans text-sm text-ink-soft">{t.note(brandName)}</p>
            <p className="font-sans text-xs text-ink-soft/70 italic mt-3">{t.burrata}</p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-auto">
          {shots.map((s, i) => (
            <Tile key={i} s={s} alt={t.alts[i]} />
          ))}
        </div>
      </div>
    </section>
  );
};
